module.exports = __webpack_public_path__ + "static/img/xiaoruanmeng.6d5039e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp/xiaoruanmeng.jpg
// module id = tfIg
// module chunks = 0